/**
 * Repairs "mojibake" — text whose UTF-8 bytes were decoded as ISO-8859-1 somewhere upstream
 * (e.g. a Spring `application.properties` value read as Latin-1), so "Nová" arrives as "NovÃ¡".
 *
 * The repair is conditional and idempotent: it only triggers when the string actually contains
 * the tell-tale Latin-1 sequence (a high C2-DF lead byte followed by an 80-BF continuation), and
 * it falls back to the original string if the bytes don't form valid UTF-8. Correctly-encoded
 * text (and already-repaired text) is left untouched, so it stays safe even once the backend is
 * fixed to emit proper UTF-8.
 */
const MOJIBAKE_MARKER = /[Â-ß][-¿]/;

export function fixMojibake(value: string): string {
    if (!value || !MOJIBAKE_MARKER.test(value)) return value;
    try {
        const bytes = Uint8Array.from(value, c => c.charCodeAt(0) & 0xff);
        return new TextDecoder("utf-8", {fatal: true}).decode(bytes);
    } catch {
        return value;
    }
}
